<script setup lang="ts">
import { inject } from 'vue';
import { VtkViewContext } from './vtk/context';
defineProps<{ disabled: boolean }>();
const view = inject(VtkViewContext)!;
</script>

<template>
  <div class="view-zoom-controls" data-testid="view-zoom" role="group" aria-label="视图缩放"
    @pointerdown.stop @pointerup.stop @click.stop @dblclick.stop @wheel.stop>
    <button type="button" data-testid="view-zoom-out" aria-label="缩小" title="缩小（当前视图）"
      :disabled="disabled" @click="view.zoomCamera?.(1 / 1.25)">−</button>
    <button type="button" data-testid="view-zoom-in" aria-label="放大" title="放大（当前视图）"
      :disabled="disabled" @click="view.zoomCamera?.(1.25)">＋</button>
    <button type="button" data-testid="view-zoom-fit" title="重置相机，使整个影像适应当前窗口"
      :disabled="disabled" @click="view.resetCamera()">适应窗口</button>
  </div>
</template>

<style scoped>
.view-zoom-controls { position: absolute; bottom: 8px; left: 50%; transform: translateX(-50%); z-index: 10;
  display: flex; gap: 1px; border: 1px solid #687789; border-radius: 5px; background: #17202deb; overflow: hidden;
  color: #fff; text-shadow: none; font-size: 12px; pointer-events: auto; }
button { min-width: 32px; min-height: 30px; padding: 4px 8px; border: 0; border-radius: 0; background: transparent; color: inherit; cursor: pointer; white-space: nowrap; }
button:first-child, button:nth-child(2) { font-size: 19px; line-height: 20px; }
button:hover { background: #3d536d; } button:focus-visible { outline: 2px solid #75c9ff; outline-offset: -2px; }
button:disabled { opacity: .45; cursor: default; }
</style>
